export { GroupSimpleEventTabsLayout } from './GroupSimpleEventTabsLayout';
